import { render } from "./FeedLoaderForm.vue?vue&type=template&id=9d747f0c&scoped=true&lang=html"
import script from "./FeedLoaderForm.vue?vue&type=script&lang=js"
export * from "./FeedLoaderForm.vue?vue&type=script&lang=js"

import "./FeedLoaderForm.vue?vue&type=style&index=0&id=9d747f0c&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-9d747f0c"

export default script